import { render, staticRenderFns } from "./ButtonCustomFieldComponent.vue?vue&type=template&id=b3fcdca4&"
import script from "./ButtonCustomFieldComponent.vue?vue&type=script&lang=js&"
export * from "./ButtonCustomFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports